import { ButtonHTMLAttributes, forwardRef } from "react";
import { ThemeClassNames, withTheme } from "./withTheme";
import { useDebouncedCallback } from "../hooks/common/useDebouncedCallback";
import { twMerge } from "tailwind-merge";
import { Portal } from "./Portal";
import { SELECTOR } from "%/constant";
// import { useDebounce } from "./useDebounce";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  delay?: number;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, delay = 50, onClick, ...props }, ref) => {
    const debouncedClick = useDebouncedCallback(onClick, delay);
    // const debouncedClick = useDebounce()\
    return (
      <button
        {...props}
        ref={ref}
        data-touch
        onClick={debouncedClick}
        className={twMerge(
          "inline-flex gap-4 items-center justify-center [&>*]:pointer-events-none disabled:opacity-30 text-xs bg-white",
          className
        )}
      >
        {children}
      </button>
    );
  }
);
export const ArrowButton = ({ children, ...props }: ButtonProps) => (
  <Button
    {...props}
    // className={`inline-flex gap-4 items-center justify-center${addClassName( // className )}`}
  >
    {children}

    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="inherit"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7402 15.5302L14.2602 12.0002L10.7402 8.47021"
        stroke="inherit"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Button>
);

export const FixedButton = ({ children, className, ...props }: ButtonProps) => (
  <Portal id={SELECTOR.APP}>
    <div className="p-5 bg-white shadow-2xl">
      <Button
        {...props}
        className={twMerge(className, "w-full !rounded-full !text-lg")}
      >
        {children}
      </Button>
    </div>
  </Portal>
);
const className: ThemeClassNames = {
  primary: "bg-yellow text-white",
  secondary: "border-yellow border text-yellow",
  secondary2: "border-[#7D6DFF] border text-[#7D6DFF]",
  tertiary: "bg-[#E9E9E9]",
  quaternary: "border",
  md: "px-4 h-10 text-sm font-medium rounded",
  xl: "px-4 h-14 text-base",
};
export const ThemedButton = withTheme(Button, className);

export const ThemedArrowButton = withTheme(ArrowButton, className);
export const ThemedFixedButton = withTheme(FixedButton, className);
